import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPencilLine: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPencilLine"><Path d="M16.5 1.58582L22.4142 7.50003L7.91421 22H2V16.0858L16.5 1.58582Z" fill="currentColor"/><Path d="M13 20V22H22V20H13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPencilLine;
